import {AfterViewInit, Component, ElementRef, EventEmitter, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {MenuAsideService, SubheaderService} from '../../../../core/_base/layout';
import {HttpClient} from '@angular/common/http';
import {AppHotelModel} from '../../../models/app-hotel.model';
import {Router} from '@angular/router';
import {Observable, Subject, Subscription} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {MatOptionSelectionChange} from '@angular/material';
import {MenuSectionModel} from '../../../models/menu-section.model';
import {MenuCategoryModel} from '../../../models/menu-category.model';
import {MenuItemModel} from '../../../models/menu-item.model';
import {MenuItemBulletListModel} from '../../../models/menu-item-bullet-list.model';
import {environment} from '../../../../../environments/environment';

export interface PlaceSuggestion {
  suggestions: Suggestion[];
}

export interface Suggestion {
  entities: Hotels[];
  group: string;
}

export interface Hotels {
  name: string;
  destinationId: number;
  longitude: number;
  latitude: number;
}

export class Room {
  name: string;
  additionalInfo: any;
  images: any[];
  maxOccupancy: any;
  ratePlans: any[];
}

@Component({
  selector: 'kt-add-hotel',
  templateUrl: './add-hotel.component.html',
  styleUrls: ['./add-hotel.component.scss']
})
export class AddHotelComponent implements OnInit, AfterViewInit {
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();

  @Output()
  locationChange: EventEmitter<Hotels> = new EventEmitter<Hotels>();
  searchOptions: Subject<Hotels[]> = new Subject<Hotels[]>();
  private valueChangesSub: Subscription;
  private choosenOption: Hotels;
  private userInputTimeout: number;
  private requestSub: Subscription;

  @ViewChild('wizard', {static: true}) el: ElementRef;
  @ViewChild('map', {static: true}) mapElement: any;
  map: google.maps.Map;
  submitted = false;
  public appHotel: AppHotelModel = new AppHotelModel();
  private element: HTMLInputElement;
  ir: boolean;
  ar: boolean;
  de: boolean;
  fr: boolean;
  ru = true;
  es: boolean;
  en = true;
  language = [];
  mapProperties: any;
  tr = true;
  wizard: any;
  photos = [];
  api = false;
  cIn: Date;
  cOut: Date;
  roomFromApi = false;

  constructor(private zone: NgZone,
              elRef: ElementRef,
              private http: HttpClient,
              private subheaderService: SubheaderService,
              private menuAsideService: MenuAsideService,
              private router: Router
  ) {
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.element = elRef.nativeElement;
    this.subheaderService.title$.next({title: 'Hotel Installation', desc: ''});

    this.valueChangesSub = this.myControl.valueChanges.subscribe((value) => {
      if (this.userInputTimeout) {
        window.clearTimeout(this.userInputTimeout);
      }

      if (!value || value.length < 3) {
        this.searchOptions.next(null);
        return;
      }
      this.userInputTimeout = window.setTimeout(() => {
        this.generateSuggestions(value);
      }, 300);
    });
    this.cIn = new Date(new Date().setDate(new Date().getDate() + 10));
    this.cOut = new Date(new Date().setDate(new Date().getDate() + 17));
  }

  private generateSuggestions(text: string) {
    const url = `https://hotels4.p.rapidapi.com/locations/search?locale=en_US&query=` + text;
    if (this.requestSub) {
      this.requestSub.unsubscribe();
    }
    this.requestSub = this.http.get(url, {
      headers: {
        'x-rapidapi-host': 'hotels4.p.rapidapi.com',
        'x-rapidapi-key': '71202dba07msh72a019214be9f23p186e7ajsn96446d7911df'
      }

    }).subscribe((data: PlaceSuggestion) => {
      if (data) {
        const filteredData = data.suggestions.find(x => x.group == 'HOTEL_GROUP');
        this.searchOptions.next(filteredData.entities);
      }
    }, err => {
      console.log(err);
    });
  }

  private getDetail(id: number) {
    const Outyear = this.cOut.getFullYear();
    let Outmonth;
    if ((this.cOut.getMonth() + 1).toString().length == 1) {
      Outmonth = '0' + (this.cOut.getMonth() + 1);
    } else {
      Outmonth = (this.cOut.getMonth() + 1);
    }
    let Outday;
    if ((this.cOut.getDate() + 1).toString().length == 1) {
      Outday = '0' + (this.cOut.getDate() + 1);
    } else {
      Outday = (this.cOut.getDate() + 1);
    }
    const Inyear = this.cIn.getFullYear();
    let Inmonth;
    if ((this.cIn.getMonth() + 1).toString().length == 1) {
      Inmonth = '0' + (this.cIn.getMonth() + 1);
    } else {
      Inmonth = (this.cIn.getMonth() + 1);
    }
    let Inday;
    if ((this.cIn.getDate() + 1).toString().length == 1) {
      Inday = '0' + (this.cIn.getDate() + 1);
    } else {
      Inday = (this.cIn.getDate() + 1);
    }
    const rooms: MenuItemModel[] = [];
    const urlTR = 'https://hotels4.p.rapidapi.com/properties/get-details?locale=tr_TR&currency=USD&checkOut='
      + Outyear + '-' + Outmonth + '-' + Outday + '&adults1=1&checkIn=' + Inyear + '-' + Inmonth + '-' + Inday + '&id=' + id.toString();
    const urlEN = urlTR.replace('tr_TR', 'en_EN');
    const urlRU = urlTR.replace('tr_TR', 'ru_RU');

    const roomSection: MenuSectionModel = new MenuSectionModel(0, 0, 39, true, true, 'Rooms', true);
    const roomCategory: MenuCategoryModel = new MenuCategoryModel(0, 105, '{"en":"Rooms", "tr":"Odalar", "ru":"комнаты"}', 0, 0);
    roomSection.menu_categories = [roomCategory];
    this.http.get(urlTR, {
      headers: {
        'x-rapidapi-host': 'hotels4.p.rapidapi.com',
        'x-rapidapi-key': '71202dba07msh72a019214be9f23p186e7ajsn96446d7911df'
      }
    }).subscribe((details: any) => {
      if (details.result == 'OK') {
        this.appHotel.address = details.data.body.propertyDescription.address.fullAddress;
        this.appHotel.post_code = details.data.body.propertyDescription.address.postalCode;
        this.appHotel.city = details.data.body.propertyDescription.address.cityName;
        this.appHotel.country = details.data.body.propertyDescription.address.countryName;
        this.appHotel.lat_lng = details.data.body.pdpHeader.hotelLocation.coordinates.latitude.toString() + ',' + details.data.body.pdpHeader.hotelLocation.coordinates.longitude.toString();
        if (details.data.body.roomsAndRates) {
          this.roomFromApi = true;
          console.log('Odalar geldi');
          details.data.body.roomsAndRates.rooms.forEach(x => {
            const room: MenuItemModel = new MenuItemModel();
            room.photos = '';
            room.menu_item_bullet_lists = [];
            room.name += '{"tr":"' + x.name.replace('"', '\'') + '",';
            room.description += '{"tr":"' + x.additionalInfo.description.replace('"', '\'') + '",';
            x.images.forEach(y => {
              room.photos += y.fullSizeUrl.replace('_b', '_w') + ',';
            });
            x.additionalInfo.details.amenities.forEach(y => {
              const bullet: MenuItemBulletListModel = new MenuItemBulletListModel();
              bullet.title += '{"tr":"' + y.replace('"', '\'') + '",';
              room.menu_item_bullet_lists.push(bullet);
            });
            if (x.maxOccupancy) {
              room.adult_count = x.maxOccupancy.total;
            }
            if (x.maxOccupancy) {
              room.child_count = x.maxOccupancy.children;
            }
            rooms.push(room);
          });

          this.http.get(urlEN, {
            headers: {
              'x-rapidapi-host': 'hotels4.p.rapidapi.com',
              'x-rapidapi-key': '71202dba07msh72a019214be9f23p186e7ajsn96446d7911df'
            }
          }).subscribe((enDetails: any) => {
            if (enDetails.result == 'OK') {
              enDetails.data.body.roomsAndRates.rooms.forEach((x, i) => {
                rooms[i].name += '"en":"' + x.name.replace('"', '\'') + '",';
                rooms[i].description += '"en":"' + x.additionalInfo.description.replace('"', '\'') + '",';
                x.additionalInfo.details.amenities.forEach((y, j) => {
                  rooms[i].menu_item_bullet_lists[j].title += '"en":"' + y.replace('"', '\'') + '",';
                });
              });
              this.http.get(urlRU, {
                headers: {
                  'x-rapidapi-host': 'hotels4.p.rapidapi.com',
                  'x-rapidapi-key': '71202dba07msh72a019214be9f23p186e7ajsn96446d7911df'
                }
              }).subscribe((ruDetails: any) => {
                if (ruDetails.result == 'OK') {
                  ruDetails.data.body.roomsAndRates.rooms.forEach((x, i) => {
                    rooms[i].name += '"ru":"' + x.name.replace('"', '\'') + '"}';
                    rooms[i].description += '"ru":"' + x.additionalInfo.description.replace('"', '\'') + '"}';
                    x.additionalInfo.details.amenities.forEach((y, j) => {
                      rooms[i].menu_item_bullet_lists[j].title += '"ru":"' + y.replace('"', '\'') + '"}';
                    });
                  });
                  roomCategory.menu_items = rooms;
                  this.appHotel.rooms = roomSection;
                  console.log(this.appHotel);
                }
              }, err => {
                console.log(err);
              });
            }
          }, err => {
            console.log(err);
          });
        }
      }
    }, err => {
      console.log(err);
      console.log('Lütfen tekrar dene');
    });
    setTimeout(() => {
      if (!this.roomFromApi) {
        this.cIn = new Date(this.cIn.setDate(this.cIn.getDate() + 20));
        this.cOut = new Date(this.cOut.setDate(this.cIn.getDate() + 20));
        this.getDetail(id);
        if (this.cIn.getFullYear() > new Date().getFullYear() + 2) {
          this.roomFromApi = true;
        }
      }
    }, 1000);
  }

  public optionSelectionChange(option: Hotels, event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      this.api = true;
      this.roomFromApi = false;
      this.cIn = new Date(new Date().setDate(new Date().getDate() + 10));
      this.cOut = new Date(new Date().setDate(new Date().getDate() + 17));
      this.choosenOption = option;
      this.locationChange.emit(option);
      this.appHotel.name = option.name;
      this.getDetail(option.destinationId);
      const imagesURL = 'https://hotels4.p.rapidapi.com/properties/get-hotel-photos?id=' + option.destinationId;
      this.http.get(imagesURL, {
        headers: {
          'x-rapidapi-host': 'hotels4.p.rapidapi.com',
          'x-rapidapi-key': '71202dba07msh72a019214be9f23p186e7ajsn96446d7911df'
        }
      }).subscribe((images: any) => {
        if (images) {
          this.appHotel.image_url = images.hotelImages[0].baseUrl.replace('{size}', 'z');
          for (let i = 0; i < 20; i++) {
            this.appHotel.photos += images.hotelImages[i].baseUrl.replace('{size}', 'z') + ',';
          }
          this.appHotel.photos.slice(0, this.appHotel.photos.length - 1);
        }
      }, err => {
        console.log(err);
      });
    }
  }

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterViewInit(): void {
    this.wizard = new KTWizard(this.el.nativeElement, {
      startStep: 1
    });

    this.wizard.on('beforeNext', (wizardObj) => {
      if (this.wizard.getStep() === 1) {
        if (this.appHotel.contact_name.trim() === '' || this.appHotel.contact_email.trim() === '') {
          wizardObj.stop();
        }
      }
      if (this.wizard.getStep() === 2) {
        if (this.appHotel.name === '') {
          wizardObj.stop();
        }
      }
    });

    this.wizard.on('change', () => {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);

    });
  }

  onSubmit() {
    this.submitted = true;
    this.appHotel.languages = '';
    if (this.tr) {
      this.appHotel.languages += 'tr,';
    }
    if (this.en) {
      this.appHotel.languages += 'en,';
    }
    if (this.ru) {
      this.appHotel.languages += 'ru,';
    }
    if (this.de) {
      this.appHotel.languages += 'de,';
    }
    if (this.fr) {
      this.appHotel.languages += 'fr,';
    }
    if (this.ar) {
      this.appHotel.languages += 'ar,';
    }
    if (this.ir) {
      this.appHotel.languages += 'ir,';
    }
    if (this.es) {
      this.appHotel.languages += 'es,';
    }
    this.appHotel.languages = this.appHotel.languages.slice(0, this.appHotel.languages.length - 1);

    console.log(this.appHotel);
    this.http.post(environment.baseURL + '/v2/api' + '/app_hotel', this.appHotel)
      .subscribe((data: AppHotelModel) => {
        console.log(data);
        this.router.navigateByUrl('/home').then(() => window.location.reload());
      });
  }

  setAddress(place: AppHotelModel) {
    this.zone.run(() => {
      this.appHotel.web_site_url = place.web_site_url;
      this.appHotel.place_id = place.place_id;
      this.appHotel.lat_lng = place.lat_lng;
      this.appHotel.address = place.address;
      console.log(this.appHotel.address);
      this.appHotel.contact_phone = place.contact_phone;
      this.appHotel.name = place.name;
      this.appHotel.city = place.city;
      this.appHotel.country = place.country;
      this.appHotel.post_code = place.post_code;
      this.appHotel.image_url = place.image_url;
      this.appHotel.rating = place.rating;
      this.appHotel.photos = place.photos;

      this.mapProperties = {
        center: new google.maps.LatLng(+place.lat_lng.split(',')[0], +place.lat_lng.split(',')[1]),
        zoom: 18,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapProperties);
    });
  }

  noApi(event: any) {
    if (!this.api) {
      this.appHotel = new AppHotelModel();
      this.appHotel.name = event;
    }
  }
}
